import axios from 'axios'; 

const apis =axios.create({
    baseURL:'http://localhost:5000/api'
})

export default apis